import React from "react";
import "../../assets/css/Dashboard.css";

function Footer() {
  return (
    <footer className="footer bg-white" id="dashFooter">
      <div className="container-fluid">
        <div className="d-sm-flex justify-content-center justify-content-sm-between py-2 w-100 footer_text">
          <span className="">
            Copyright ©{" "}
            <a
              href="https://kingmaster.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              King Master{" "}
            </a>
            2026
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
